import { orderBy } from 'lodash';
import { config } from '/app/config';
import { redirectTo, currentURL } from '/app/utils/navigation';

export const mapRoutesFromMd = (pages, { prefix = '', order = ['meta.index', 'meta.title'] } = {}) => {
    return orderBy(Object.values(pages)
        .map((page) => {
            if (page.disabled) {
                return
            }

            const pageComp = page.default;
            const pageName = page.name || pageComp.__name;

            return {
                path: page.path !== undefined ? page.path : pageName,
                name: [prefix, pageName].join('.'),
                component: pageComp,
                meta: {
                    title: page.title,
                    breadcrumb: page.title,
                    hidden: page.hidden,
                    index: page.index,
                    expanded: page.expand,
                },
            }
    }).filter(r => !!r), order);
}

export const isDifferentOrigin = (from = {}) => {
    const { origin } = location;
    const { referrer } = document;
    
    if (!referrer) {
        return true;
    }

    if (referrer.includes(origin)) {
        return false;
    }

    return !from.name;
}

export const surveyModeRedirection = (to) => {
    const account = config.account.url;
    const survey = config.survey.url;
    const source = new URL(currentURL() || '/');
    const url = new URL(`${account}/gateway`);

    url.searchParams.append('continue', encodeURIComponent(source.href.replace('/survey', '')));
    url.searchParams.append('follow', encodeURIComponent(`${survey}/challenge/${to.params.challenge}${source.searchParams.has('scout_id') ? `?scout_id=${source.searchParams.get('scout_id')}` : ''}`));
    url.searchParams.append('app', 'bignerve');

    return redirectTo(url.href);
}